import React, { useRef, useEffect } from "react";
import "./Collaborators.css";

const collaborators = [
  { src: `${process.env.PUBLIC_URL}/logos/thub.png`, alt: "T-Hub" },
  { src: `${process.env.PUBLIC_URL}/logos/nvidia.png`, alt: "NVIDIA" },
  { src: `${process.env.PUBLIC_URL}/logos/microsoft_hub.png`, alt: "Microsoft" },
  { src: `${process.env.PUBLIC_URL}/logos/rubrix.png`, alt: "Rubrix" },
  { src: `${process.env.PUBLIC_URL}/logos/delltech_dellstartups.png`, alt: "Dell" },
  { src: `${process.env.PUBLIC_URL}/logos/global.png`, alt: "GLOBAL" },
];

const alumni = [
  { src: `${process.env.PUBLIC_URL}/logos/capgemini.png`, alt: "Capgemini" },
  { src: `${process.env.PUBLIC_URL}/logos/utd.png`, alt: "UTD" },
  { src: `${process.env.PUBLIC_URL}/logos/fom.png`, alt: "FOM" },
  { src: `${process.env.PUBLIC_URL}/logos/liverpool.png`, alt: "Liverpool" },
  { src: `${process.env.PUBLIC_URL}/logos/techmahindra.png`, alt: "Tech Mahindra" },
];

const Collaborators = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add("fade-up");
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
  }, []);

  return (
    <section ref={sectionRef} className="collaborators-section animate-section">
      {/* Section 1 */}
      <h2 className="collab-heading mb-4">Collaborated & Proud Member of</h2>
      <div className="collab-grid">
        {collaborators.map(({ src, alt }) => (
          <img key={alt} src={src} alt={alt} />
        ))}
      </div>

      {/* Section 3 */}
      <h2 className="collab-heading mt-4 mb-4">
        Learn from the best <span className="Alumini">Alumni</span> of Global Organizations
      </h2>
      <div className="collab-grid">
        {alumni.map(({ src, alt }) => (
          <img key={alt} src={src} alt={alt} />
        ))}
      </div>
    </section>
  );
};

export default Collaborators;
